<template>
  <div class="locale-select d-flex align-items-center position-absolute top-0 ps-md-5 pb-1">
    <!-- Dropdown Button with Current Flag -->
    <div class="dropdown p-0 p-md-2">
      <button
        class="btn btn-light dropdown-toggle d-flex align-items-center gap-2"
        type="button"
        id="languageDropdown"
        data-bs-toggle="dropdown"
        aria-expanded="false"
      >
        <img
          :src="currentLocale.flag"
          alt="Current Language"
          class="rounded-circle"
        />
        <span class="d-none d-md-block">{{ currentLocale.name }}</span>
      </button>
      <ul class="dropdown-menu" aria-labelledby="languageDropdown">
        <li v-for="loc in locales" :key="loc.code">
          <button
            class="dropdown-item d-flex align-items-center gap-2"
            @click="changeLocale(loc.code)"
          >
            <img
              :src="loc.flag"
              alt=""
              class="rounded-circle"
            />
            {{ loc.name }}
          </button>
        </li>
      </ul>
    </div>
  </div>
</template>

<script lang="ts" setup>
  // Vue
  import { ref, computed } from 'vue'

  // Types
  import { CompanyLang, Locale } from '@/types'

  // Config
  import { CookieName } from '@/config/cookies'

  // Libs
  import Cookies from 'js-cookie'
  import { useI18n } from 'vue-i18n'

  // Assets
  import NlFlag from '@/assets/nl-flag.png'
  import FrFlag from '@/assets/fr-flag.png'

  // Types
  type LocaleOption = {
    code: Locale
    name: string
    flag: string
  }

  // I18n
  const { locale, t } = useI18n()

  // Locale Data
  const locales: LocaleOption[] = [
    {
      code: 'fr-FR',
      name: 'Français',
      flag: FrFlag,
    },
    {
      code: 'nl-NL',
      name: 'Nederlands',
      flag: NlFlag,
    },
  ]

  // Current Locale Display
  const currentLocale = computed(() => {
    const selectedLocale =
      locales.find(loc => loc.code === locale.value) || locales[0]

    return selectedLocale
  })

  // Change Locale Function
  const changeLocale = (selectedLocale: string): void => {
    locale.value = selectedLocale

    // Format the seleted locale
    const companyLang = selectedLocale
      .split('-')[0]
      .toLowerCase() as CompanyLang
    Cookies.set(CookieName.COMPANY_LANG, companyLang)
  }
</script>

<style scoped>
  .dropdown-item img {
    border-radius: 50%;
  }

  .locale-select {
    z-index: 10000;
  }

  img {
   width: 24px;
   height: 24px
  }

</style>
